import { Link } from 'react-router-dom';
import { articles } from '@/mocks/articles';

export default function HotArticles() {
  const hot = articles.filter((a) => a.hot).slice(0, 6);

  return (
    <section className="w-full py-12 md:py-16 px-4 md:px-6 bg-background-50">
      <div className="max-w-6xl mx-auto">
        <div className="flex items-center justify-between mb-8 md:mb-10">
          <div>
            <h2 className="font-heading text-2xl md:text-3xl text-foreground-950">
              热门文章
            </h2>
            <p className="mt-2 text-sm text-foreground-600">
              读者最爱的故事，引发无数情感共鸣
            </p>
          </div>
          <Link
            to="/category/mama-yu-guimi"
            className="hidden sm:inline-flex items-center text-sm text-primary-500 hover:text-primary-600 transition-colors duration-200 whitespace-nowrap"
          >
            查看全部
            <i className="ri-arrow-right-line ml-1"></i>
          </Link>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {hot.map((article) => (
            <Link
              key={article.slug}
              to={`/article/${article.slug}`}
              className="group flex gap-4 p-4 bg-background-100 rounded-lg hover:shadow-sm transition-all duration-300 cursor-pointer"
            >
              <div className="w-24 h-24 md:w-28 md:h-28 flex-shrink-0 rounded-md overflow-hidden">
                <img
                  src={article.coverImage}
                  alt={article.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
              </div>
              <div className="flex-1 min-w-0">
                <h3 className="font-heading text-sm md:text-base text-foreground-950 group-hover:text-primary-500 transition-colors duration-200 line-clamp-2 leading-snug">
                  {article.title}
                </h3>
                <p className="mt-1 text-xs text-foreground-500 line-clamp-2 leading-relaxed">
                  {article.excerpt}
                </p>
                <div className="mt-2 flex items-center gap-3 text-xs text-foreground-400">
                  <span>{article.date}</span>
                  <span>{article.readTime}</span>
                </div>
              </div>
            </Link>
          ))}
        </div>

        <div className="mt-6 text-center sm:hidden">
          <Link
            to="/category/mama-yu-guimi"
            className="inline-flex items-center text-sm text-primary-500 hover:text-primary-600 transition-colors duration-200 whitespace-nowrap"
          >
            查看全部故事
            <i className="ri-arrow-right-line ml-1"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}